import React from 'react';
import { View, Text } from 'react-native';
import { TraitsResultProps } from '@grapesjs/react';
import TraitPropertyField from './TraitPropertyField';

export default function CustomTraitManager({ traits }: Omit<TraitsResultProps, 'Container'>) {
  return (
    <View style={{ marginTop: 3, padding: 1, gap: 5 }}>
      {traits.length === 0 ? (
        <Text>No properties available</Text>
      ) : (
        traits.map(trait => (
          <TraitPropertyField key={trait.getId()} trait={trait} />
        ))
      )}
    </View>
  );
}
